import { APP_API_URL } from "@/consts";
import graphqlClient from "@/GQLClient";
import {
  SaveProfileDocument,
  Container_Type,
  type RelativeInput,
  type UserSaveInput,
} from "@/graphql/generated-types";
import save from "@/api/resource";
import { simpleError } from "@/stories/displays/SimpleError/SimpleError.vue";
import type { IFileState } from "@/interfaces";

/**
 * This API service is a part of Relation profile creation.
 * https://proreact.atlassian.net/browse/IBG-7037
 *
 * Example: http://localhost:5173/relative-profile-creation?t=XXXXX
 */

const DOMAIN = `${APP_API_URL}/institution/accesstoken`;

export type CreateUserProfileInput = Partial<UserSaveInput> &
  Partial<RelativeInput>;

const validateToken = async (
  code: string,
): Promise<{ accessToken?: string; id?: string }> => {
  const res = await fetch(DOMAIN, {
    headers: { Authorization: code },
  });

  if (!res.ok) {
    throw new Error(`api.relativeProfile.validateToken: ${res.status}`);
  }

  return await res.json();
};

const createUserProfile = async (
  createUserProfileInput: CreateUserProfileInput,
  profileImage: IFileState,
) => {
  const {
    email,
    password,
    roles,
    institution,
    mobile,
    lastname,
    firstname,
    relationTo,
    relationType,
    commentRelative,
  } = createUserProfileInput;

  try {
    const profileImageResourceId = await save.save({
      body: profileImage.base64,
      institution,
      container: Container_Type.People,
    });

    return await createProfile({
      image: profileImageResourceId,
      email,
      mobile,
      lastname,
      firstname,
      relationTo,
      institution,
      relationType,
      commentRelative,
      login: {
        email,
        username: email,
        password,
        roles,
      },
    });
  } catch (error) {
    simpleError("global.error_api");
    throw error;
  }
};

const createProfile = async (relativeInput: RelativeInput) => {
  const response = await graphqlClient.query({
    query: SaveProfileDocument,
    variables: {
      relative: relativeInput,
    },
  });
  return response;
};

export default {
  createUserProfile,
  validateToken,
};
